import React, { Component } from 'react';
import { Form, Col, Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Subscription } from 'rxjs';
import GetRegulatoryModeDonorByID from '../../../api/Administration/GetRegulatoryModeDonorByID';
import InsertRegulatoryModeDonor from '../../../api/Administration/InsertRegulatoryModeDonor';
import RegulatoryMode from '../../../api/Administration/Model/RegulatoryMode';
import Checkbox from '../../Checkbox';
import { AppPageWrapper } from '../../NavMenu/AppPageWrapper';
import PersonnelRegulatoryModes from "./PersonnelRegulatoryModes";
import RegulatoryModeNumberSelect from "./RegulatoryModeNumberSelect";

type RegulatoryModeNumberAttributes = keyof RegulatoryModeRanks;
interface RegulatoryModeRanks {
    SSNRank: number;
    AlternateIDRank: number;
    EmployerIDRank: number;
    CommercialLicenseRank: number;
}
interface RegulatoryModeState extends RegulatoryModeRanks {
    RegulatoryModeID: number;
    SSNDescription: string;
    EmployerDescription: string;
    AltDescription: string;
    CommercialLicenseDescription: string;
    DisplayState: boolean;
}
const DefaultRegulatoryModeOrder: RegulatoryModeState = {
    RegulatoryModeID: 0,
    SSNRank: 0, SSNDescription: "",
    EmployerIDRank: 0, EmployerDescription: "",
    AlternateIDRank: 0, AltDescription: "",
    CommercialLicenseRank: 0, CommercialLicenseDescription: "",
    DisplayState: true,
};
export default class RegulatoryModeForm extends Component<{}, RegulatoryModeState> {
    loadSubscription?: Subscription
    saveSubscription?: Subscription
    state: RegulatoryModeState = {
        ...DefaultRegulatoryModeOrder
    };

    componentWillUnmount() {
        this.loadSubscription && this.loadSubscription.unsubscribe()
        this.saveSubscription && this.saveSubscription.unsubscribe()
    }

    resetForm = () => {
        this.setState({ ...DefaultRegulatoryModeOrder });
    }
    changeRegulatoryMode = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.resetForm();
        this.loadSubscription = GetRegulatoryModeDonorByID(event.target.value).subscribe(
            data => this.setState({ ...data[0], DisplayState: true }),
            error => toast.error(error.message)
        )
    }
    handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({ ...this.state, [target.name]: value });
    }

    checkAssignedRank(data: number[]) {
        if (!data['includes'](1)) {
            return true;
        }
    }

    validate = () => {
        let array = [this.state.SSNRank, this.state.EmployerIDRank, this.state.AlternateIDRank, this.state.CommercialLicenseRank];
        let isRankOneAssigned = this.checkAssignedRank(array);
        if (isRankOneAssigned) {
            toast.error("Assign Rank 1");
            return false;
        }
        return true;
    }
    handleSubmit = (event: React.FormEvent<HTMLElement>) => {
        event.preventDefault();
        if (!this.validate()) {
            return false;
        }
        this.saveSubscription = InsertRegulatoryModeDonor(this.state as RegulatoryMode).subscribe(
            data => toast.success(data),
            error => toast.error(error.message)
        )
    }

    handleRankSelect = (name: RegulatoryModeNumberAttributes, eventKey: string | null) => {
        const RegulatoryModeNumberAttributes: RegulatoryModeNumberAttributes[] = ["SSNRank", "AlternateIDRank", "EmployerIDRank", "CommercialLicenseRank"];
        const foundEntry: number = parseInt(eventKey || "0");
        const newState: RegulatoryModeState = { ...this.state, [name]: foundEntry };
        const numbersToReset = RegulatoryModeNumberAttributes.filter((record) =>
            record !== name && this.state[record] === foundEntry
        );
        numbersToReset.map(item => { newState[item] = 0 });
        this.setState(newState);
    }

    RegulatoryField = (label: string, name: RegulatoryModeNumberAttributes, description: keyof RegulatoryModeState) => {
        const inputChange = (e: React.ChangeEvent<HTMLInputElement>) => this.handleInputChange(e);
        const getValue = (key: keyof RegulatoryModeState): string => ((this.state[key] || "").toString() || "");
        const getNumberValue = (key: RegulatoryModeNumberAttributes) => parseInt((this.state[key] || "").toString());
        const numberInputChange = (eventKey: string | null, _: React.SyntheticEvent<unknown>) => { this.handleRankSelect(name, eventKey); };
        return <Form.Row>
            <Form.Label column md={3}>{label}</Form.Label>
            <Col>
                <RegulatoryModeNumberSelect value={getNumberValue(name)} onChange={numberInputChange} />
            </Col>
            <Form.Label column md={2}>Display Description</Form.Label>
            <Col md={6}>
                <Form.Control type="text" name={`${description}`} value={getValue(description)} onChange={inputChange} />
            </Col>
        </Form.Row>
    }

    render = () => {
        return (
            <AppPageWrapper showNav>
                <Modal.Dialog size="xl">
                    <Modal.Header>
                        <Modal.Title>REGULATORY MODE DONOR ID</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Row>
                                <Form.Label column md={3} className="required">Regulatory Mode</Form.Label>
                                <Col md={9}>
                                    <PersonnelRegulatoryModes
                                      selected={this.state.RegulatoryModeID}
                                      onChange={this.changeRegulatoryMode}
                                    />
                                </Col>
                            </Form.Row>
                            <Form.Row>
                                <Col md={{ span: 1, offset: 3 }} className="rank"><label>Rank</label></Col>
                            </Form.Row>
                            {this.RegulatoryField("Social Security #", "SSNRank", "SSNDescription")}
                            {this.RegulatoryField("Employer ID", "EmployerIDRank", "EmployerDescription")}
                            {this.RegulatoryField("Alternate ID", "AlternateIDRank", "AltDescription")}
                            {this.RegulatoryField("Commercial License", "CommercialLicenseRank", "CommercialLicenseDescription")}
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.resetForm()} className="fixed-w5">Cancel</Button>
                        <Button variant="primary" onClick={(e) => this.handleSubmit(e)} disabled={!this.state.RegulatoryModeID} className="fixed-w5 ml-2">Submit</Button>
                    </Modal.Footer>
                </Modal.Dialog>
            </AppPageWrapper>
        );
    }
}
